const project_lists_client = "/project_lists_client";
const tabledata = "/tabledata";
const qcSubmitclient = "qcSubmitclient";
const projStats = "/projStats";

export { project_lists_client, tabledata, qcSubmitclient, projStats };
